module.exports = __webpack_public_path__ + "static/media/ml4.41a2e28d.jpg";